// extracted by mini-css-extract-plugin
module.exports = {"mobileAccordionContainer":"MobileAccordionContainerV2-module__mobileAccordionContainer___2050c","selectedOption":"MobileAccordionContainerV2-module__selectedOption___28MAM"};